import { render, staticRenderFns } from "./DevelopStandardManage.vue?vue&type=template&id=1f1f476a&scoped=true"
import script from "./DevelopStandardManage.vue?vue&type=script&lang=js"
export * from "./DevelopStandardManage.vue?vue&type=script&lang=js"
import style0 from "./DevelopStandardManage.vue?vue&type=style&index=0&id=1f1f476a&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1f476a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f1f476a')) {
      api.createRecord('1f1f476a', component.options)
    } else {
      api.reload('1f1f476a', component.options)
    }
    module.hot.accept("./DevelopStandardManage.vue?vue&type=template&id=1f1f476a&scoped=true", function () {
      api.rerender('1f1f476a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screeningConfig/physicalConfig/developStandardManage/DevelopStandardManage.vue"
export default component.exports